import { CanActivate } from '@angular/router';

export class RootAuthGuard implements CanActivate {

  public canActivate() {
    return true;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/guards/root-auth.guard.ts